import React from "react";
import { InfoRowProps } from "../../types/policyTypes";

export default function InfoRow({ label, value }: InfoRowProps) {
  return (
    <div className="flex items-start">
      <span className="w-32 shrink-0 text-[13px] font-bold text-theme-text-soft">{label}</span>
      <span className="flex-1 text-right text-[13px] font-bold leading-tight text-theme-text">
        {value}
      </span>
    </div>
  );
}
